import React from "react";

interface Service {
  title: string;
  description: string;
}

interface ServicesSectionProps {
  title: string;
  description: string;
  services: Service[];
}

const ServicesSection: React.FC<ServicesSectionProps> = ({
  title,
  description,
  services,
}) => {
  return (
    <>

      <section className="bg-[#10031dff] py-16 text-white">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-8 font-starforge">{title}</h2>
          <p className="text-xl mb-12 font-sans">{description}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="p-6 bg-[#1f142bff] shadow-lg rounded-lg border border-solid"
                style={{
                  backgroundColor: "#1f142bff",
                  borderColor: "transparent",
                  borderImage:
                    "linear-gradient(to right, #5e5568ff, #5e5568ff) 1",
                  boxShadow: "0px 4px 15px rgba(255, 255, 255, 0.2)",
                  color: "var(--text-color)",
                }}
              >
                <h3 className="text-2xl font-bold mb-4 font-orbitron">
                  {service.title.split(" ").map((word, idx) =>
                    word.toLowerCase() === "ai" ? (
                      <span key={idx} className="text-[#ffffff]">
                        {word}
                      </span>
                    ) : (
                      <span key={idx}>{word} </span>
                    ),
                  )}
                </h3>
                <p className="font-sans">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesSection;
